import React, {Component} from 'react';


class Footer extends React.Component {
  render() {
return  <div className="nk-sidebar-menu" data-simplebar>
                                   {/*  <!-- Menu --> */}
                                    <ul className="nk-menu">
                                        <li className="nk-menu-heading">
                                            <h6 className="overline-title">Menu</h6>
                                        </li>
                                        <li className="nk-menu-item">
                                            <a href="/portal" className="nk-menu-link">
                                                <span className="nk-menu-icon"><em className="icon ni ni-dashboard"></em></span>
                                                <span className="nk-menu-text">Dashboard</span>
                                            </a>
                                        </li>
                                        {/*<li className="nk-menu-item">
                                            <a href="/subscriptions" className="nk-menu-link">
                                                <span className="nk-menu-icon"><em className="icon ni ni-file-text"></em></span>
                                                <span className="nk-menu-text">My Subscription</span>
                                            </a>
                                        </li>
                                        <li className="nk-menu-item">
                                            <a href="/payments" className="nk-menu-link">
                                                <span className="nk-menu-icon"><em className="icon ni ni-report-profit"></em></span>
                                                <span className="nk-menu-text">Payment History</span>
                                            </a>
                                        </li>
                                        <li className="nk-menu-item">
                                            <a href="/downloads" className="nk-menu-link">
                                                <span className="nk-menu-icon"><em className="icon ni ni-download-cloud"></em></span>
                                                <span className="nk-menu-text">Download</span>
                                            </a>
                                        </li>*/}
                                        {/* <li className="nk-menu-item">
                                            <a href="/profile" className="nk-menu-link">
                                                <span className="nk-menu-icon"><em className="icon ni ni-account-setting"></em></span>
                                                <span className="nk-menu-text">Account Setting</span>
                                            </a>
                                        </li> */}
                                        {/*<li className="nk-menu-heading">
                                            <h6 className="overline-title">See Others</h6>
                                        </li>
                                        <li className="nk-menu-item">
                                            <a href="#" className="nk-menu-link">
                                                <span className="nk-menu-icon"><em className="icon ni ni-files"></em></span>
                                                <span className="nk-menu-text">Pre-Built Pages</span>
                                            </a>
                                            <ul className="nk-menu-sub">
                                                <li className="nk-menu-item"><a href="/pricing" className="nk-menu-link"><span className="nk-menu-text">Pricing</span></a></li>
                                                <li className="nk-menu-item"><a href="/team-access" className="nk-menu-link"><span className="nk-menu-text">Team Access</span></a></li>
                                                <li className="nk-menu-item"><a href="/profile-activity" className="nk-menu-link"><span className="nk-menu-text">Login Activity</span></a></li>
                                                <li className="nk-menu-item"><a href="/invoices" className="nk-menu-link"><span className="nk-menu-text">Invoices <span className="count">(2)</span></span></a></li>
                                                <li className="nk-menu-item"><a href="/invoice-details" className="nk-menu-link"><span className="nk-menu-text">View Invoice</span></a></li>
                                                <li className="nk-menu-item"><a href="/tickets" className="nk-menu-link"><span className="nk-menu-text">Tickets <span className="count">(5)</span></span></a></li>
                                                <li className="nk-menu-item"><a href="/ticket-details" className="nk-menu-link"><span className="nk-menu-text">Ticket Details</span></a></li>
                                                <li className="nk-menu-item"><a href="/support" className="nk-menu-link"><span className="nk-menu-text">Support</span></a></li>
                                                <li className="nk-menu-item"><a href="/subscriptions-details" className="nk-menu-link"><span className="nk-menu-text">Subscription Details</span></a></li>
                                            </ul>
                                        </li>*/}
                                    </ul>
                                   {/*  <!-- Menu --> */}
                                    {/* <ul className="nk-menu nk-menu-sm">
                                        <li className="nk-menu-heading">
                                            <span>Help Center</span>
                                        </li>
                                        <li className="nk-menu-item">
                                            <a href="/faqs" className="nk-menu-link">
                                                <span className="nk-menu-text">FAQs</span>
                                            </a>
                                        </li>
                                        <li className="nk-menu-item">
                                            <a href="/contact" className="nk-menu-link">
                                                <span className="nk-menu-text">Contact</span>
                                            </a>
                                        </li>
                                        <li className="nk-menu-item">
                                            <a href="/support" className="nk-menu-link">
                                                <span className="nk-menu-text">Support</span>
                                            </a>
                                        </li>
                                    </ul> */}
                                </div>
    
    }
}
export default Footer;